import React, { useContext } from 'react';
import { Row, Col } from 'antd';
import Avatar from '../../components/Avatar';
import CellFullNameWithEmail from '../../components/UserList/components/CellFullNameWithEmail';
import Modal from '../../../main/components/Modal';
import { Divider } from '../../components/Divider';
import Spinner from '../../../main/components/Spinner';
import GlobalContext from '../../../main/utils/GlobalContext';

const ModalBmcTeamMembers = ({ visible, onClose, users, loading = false }) => {
  const { locales } = useContext(GlobalContext);
  return (
    <Modal
      size="sm"
      isOpen={visible}
      title={locales.admin.teamMemberTime}
      onClose={onClose}
    >
      <div className="team-members-modal">
        {loading && (
          <div className="team-members-modal__loading">
            <Spinner />
          </div>
        )}
        {!loading && (
          <>
            <Row>
              <Col span={16}>
                <div className="team-members-modal__title">
                  {locales.admin.teamMembers}:
                </div>
              </Col>
              <Col span={4}>
                <div className="team-members-modal__title">
                  {locales.admin.activityTotal}
                </div>
              </Col>
              <Col span={4}>
                <div className="team-members-modal__title">
                  {locales.admin.last30Days}
                </div>
              </Col>
            </Row>
            {users.map((user) => (
              <Row
                align="middle"
                className="team-members-modal__row"
                key={user.id}
              >
                <Col span={16}>
                  <div className="team-members-modal__avatar">
                    <Avatar
                      size="lg"
                      alt={user.attributes.email}
                      fullName={user.attributes.name}
                      url={user.attributes.image.cropped}
                    />
                    <CellFullNameWithEmail
                      user={{
                        id: user.attributes.id,
                        fullName: user.attributes.name,
                        email: user.attributes.email,
                      }}
                    />
                  </div>
                </Col>
                <Col span={4}>
                  <span className="team-members-modal__value">
                    {user.attributes.siteTotalUsage} {locales.admin.min}
                  </span>
                </Col>
                <Col span={4}>
                  <span className="team-members-modal__value">
                    {user.attributes.siteLastTotalUsage} {locales.admin.min}
                  </span>
                </Col>
              </Row>
            ))}
          </>
        )}
      </div>
      <Divider />
    </Modal>
  );
};

export default ModalBmcTeamMembers;
